/** sessionStorage key written by auth-redirect.html after MSAL loginRedirect. */
export const PENDING_MICROSOFT_ID_TOKEN_KEY = 'pendingMicrosoftIdToken';

export const MSAL_REDIRECT_PATH = '/auth-redirect.html';

export function getMsalRedirectUri(): string {
  return `${window.location.origin}${MSAL_REDIRECT_PATH}`;
}
